<template>
  <div class="container row">
    <aside class="sidenav" ref="sidenav">
      <header></header>
      <main>
        <ul>
          <li
            @click.prevent="hideSidenav"
            :class="activeRoute === 'Profile' ? 'active' : ''"
          >
            <router-link class="nav-link" :to="{ name: 'Profile' }">
              <i class="material-icons">account_circle</i>
              <span>Profile</span>
            </router-link>
          </li>
          <li
            @click.prevent="hideSidenav"
            :class="activeRoute === 'Orders' ? 'active' : ''"
          >
            <router-link class="nav-link" :to="{ name: 'Orders' }">
              <i class="material-icons">shop</i>
              <span>Orders</span>
            </router-link>
          </li>
          <li class="divider"></li>
          <li @click.prevent="logout">
            <a href="" class="nav-link" @click.prevent="() => {}">
              <i class="material-icons">directions_walk</i>
              <span>Logout</span>
            </a>
          </li>
        </ul>
      </main>
    </aside>
    <section class="content">
      <router-view />
    </section>

    <button
      class="fab sidenav-trigger hide-on-laptop-and-up"
      @click.prevent="sidenavOpen = !sidenavOpen"
    >
      <i class="material-icons">
        {{ sidenavOpen ? "close" : "menu" }}
      </i>
    </button>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import { mapGetters } from "vuex";

export default {
  name: "Profile",
  computed: {
    ...mapGetters({
      logoutStatus: "Auth/logoutStatus",
      logoutMessage: "Auth/logoutMessage",
    }),
  },
  data() {
    return {
      activeRoute: "",
      sidenavOpen: false,
    };
  },
  watch: {
    $route(to) {
      this.handleRouteChange(to);
    },
  },
  created() {
    this.handleRouteChange();
  },
  mounted() {
    T.sidenav();

    this.handleSidenavFabClick();
  },
  methods: {
    handleRouteChange(route) {
      route = route ?? this.$route;

      const name = route.name.toLowerCase();

      if (name.includes("order")) {
        this.activeRoute = "Orders";
      } else if (name.includes("profile")) {
        this.activeRoute = "Profile";
      }
    },
    handleSidenavFabClick() {
      setTimeout(() => {
        if (this.$refs.sidenav.classList.contains("active")) {
          this.sidenavOpen = true;
        } else {
          this.sidenavOpen = false;
        }
      }, 500);
    },
    hideSidenav() {
      this.sidenavOpen = false;
      this.$refs.sidenav.classList.remove("active");
    },

    // TODO: Have this in a mixin and reuse where needed
    logout() {
      this.$store.dispatch("Auth/logout").then(() => {
        if (this.logoutStatus === 2) {
          // TODO: notify the user of successful logout
          console.log(`${this.logoutMessage}`);
          this.$store.dispatch("reset");
          this.$router.push({ name: "Landing" });
        } else if (this.logoutStatus === 3) {
          // TODO: notify the user of the error (in a user friendly way)
          console.log(`${this.logoutMessage}`);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sidenav {
  left: 0;
  padding-bottom: 1rem;

  header {
    height: 20vh;
  }
}
.content {
  margin-bottom: 3rem;
  flex: 1;
}
.fab.sidenav-trigger {
  bottom: 2rem;
}

@include laptop-and-up {
  .sidenav {
    height: max-content;
    margin-top: 1rem;
    position: sticky;
    top: 70px;
    border-radius: 5px;

    header {
      height: 2rem;
    }
  }

  .content {
    margin: 1rem 0 0 5rem;
    flex: 1;
  }
}
</style>

<style lang="scss">
.theme-light {
  .sidenav {
    background-color: white !important;

    @include laptop-and-up {
      // background-color: transparentize($primary-color, 0.9) !important;
    }
  }
}
</style>
